import React, { Component } from "react";
import { db, storage, firebaseApp, auth } from "./firebase";
import "./upload.css";
import editor from "./editor.jpg";
import academ from "./academ.jpg";
import bio from "./bio.jpg";
import chil from "./chil.jpg";
import fic from "./fic.jpg";
import life from "./layf.jpg";
import polit from "./polit.jpg";
import fan from "./fan.jpg";
import most from "./popula.jpg";
import art from "./art.jpg";
import bus from "./busines.jpg";
import envi from "./envi.jpg";
import heal from "./heal.jpg";
import grow from "./grow.jpg";
import reli from "./reli.jpg";
import tec from "./tec.jpg";
import market from "./pm.png";
import mac from "./mac.jpg";
import not from "./not.jpg";
import pdflogo from "./pdflog.png";
import captcha from "./recaptcha.png";

class Upload extends Component {
  state = {
    checked: false,
    name: "",
    kitob: "",
    post: [],
    uploaded: false,
  };
  componentDidMount() {
    db.collection("yangipost")
    
    .onSnapshot((response) => {
      this.setState({
        post: response.docs.map((doc) => {
          return doc.data();
        }),
      });
    });
    auth.onAuthStateChanged((person) => {
      this.setState({
        user: person,
      });
    });
  }

  handleRobot = () => {
    this.setState({
      checked: !this.state.checked,
    });
  };

  handleFile = (event) => {
    this.setState({
      kitob: event.target.files[0],
    });
  };
  handleUpload = () => {
    const uploading = storage
      .ref(`yangipost/${this.state.kitob.name}`)
      .put(this.state.kitob);
    uploading.on(
      "state_changed",
      () => {
        console.log("Kitob qoyilyapti");
      },
      (err) => {
        console.error(err.message);
      },
      () => {
        storage
          .ref("yangipost")
          .child(this.state.kitob.name)
          .getDownloadURL()
          .then((url) => {
            console.log(url);
            db.collection("yangipost").add({
              timestamp: new Date().getTime(),
              image: url,
              name: this.state.name,
            });
          })
          .then(() => {
            this.setState({
              kitob: "",
              name: null,
            });
          });
      }
    );
   setTimeout(()=>{
     window.location.href="/"
   }, 5000)
  };

  handleuploaded = () => {
    this.setState({
      uploaded: !this.state.uploaded,
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className="bek">
          <div className="mainpart container">
            <div className="leftprem container">
              <p className="share">Share your documents</p> <br />
              <div className="kvadrat container">
                <div className="jorjee">
                  <span className="million jorjee">
                    <p>
                      Reach more than 4 million <br />
                      readers{" "}
                    </p>
                    <p>Upload in seconds</p>
                    <p>
                      Index with PDF Drive and <br />
                      other search engines
                    </p>
                  </span>{" "}
                  <br />
                  <span className="bcc">
                    <input
                      onChange={this.handleFile}
                      className="typefile"
                      type="file"
                    />
                    <p className="dvv">We support PDF,EPUB,MOBI,DOC,DOCX</p>
                  </span>
                  <span className="">
                    <input
                      onChange={(event) => {
                        this.setState({ name: event.target.value });
                      }}
                      className="yll"
                      type="text"
                      placeholder="File Title"
                    />
                  </span>
                  <span className="robocheck">
                    <span className="norobo">
                      <input
                        onClick={this.handleRobot}
                        type="checkbox"
                        name=""
                        id=""
                      />
                      <p>I'm not a Robot</p>
                    </span>
                    <span>
                      <img className="captcha" src={captcha} alt="" />
                    </span>
                  </span>
                  {this.state.checked === true ? (
                    <span className="gbn">
                      <button onClick={this.handleUpload} className="uploadqil">
                        Upload
                      </button>
                    </span>
                  ) : (
                    <span className="gbn">
                      <button className="uploadqilma">Upload</button>
                    </span>
                  )}
                </div>
              </div>
              <div className="kitobga conte">
                <span className="weekbooks">
                  <i className="fas fa-gem"></i>
                  <h3>My Uploads</h3>
                </span>
                {this.state.post.map((post) => {
                  return (
                    <>
                      {this.state.uploaded === true ? (
                        <div className="miller">
                          <div className="ccol">
                            <div className="ag">
                              <img
                                className="yeavv"
                                onClick={this.handleuploaded}
                                src={post.image}
                                alt=""
                              />
                            </div>

                            <div className="col-right1">
                              <p className="cv1">{post.name}</p>
                              <p className="green1">
                                155 Pages / 2020 / 1.3 MB / 0 Downloads
                              </p>
                              <p className="mualif1">
                                This Book Uploaded A Minute Ago...{" "}
                              </p>
                              <span className="imporbtn1">
                                <button className="prbtn">Preview</button>
                                <a href={post.image} download>
                                  <button className="dobtn">Download</button>
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="inf">
                          <div className="ccol">
                            <div className="col-left">
                              <img
                                onClick={this.handleuploaded}
                                src={post.image}
                                alt=""
                              />
                            </div>

                            <div className="col-right">
                              <h5>{post.name}</h5>
                              <p className="page">
                                155 Pages / 2020 / 1.3 MB / 0 Downloads
                              </p>
                              <p className="word">
                                This Book Uploaded A Minute Ago...{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
              </div>
            </div>
            <div className="rightprem">
              <div className="klarall">
                <p>
                  <span>Pdfdrive:hope</span> Give books away. Get books you
                  wont.
                </p>
                <div className="hamakitob">
                  <div>
                    <a href="https://www.pdfdrive.com/category/113">
                      <span className="poo">
                        <img src={editor} alt="" /> <p>Editor's Picks</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/6">
                      <span className="poo">
                        <img src={academ} alt="" /> <p>Academic & Education</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/16">
                      <span className="poo">
                        <img src={bio} alt="" /> <p>Biograhpy</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/17">
                      <span className="poo">
                        <img src={chil} alt="" /> <p>Children & Youth</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/11">
                      <span className="poo">
                        <img src={fic} alt="" /> <p>Fiction & Literature</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/19">
                      <span className="poo">
                        <img src={life} alt="" /> <p>Lifestyle</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/15">
                      <span className="poo">
                        <img src={polit} alt="" /> <p>Politics & Laws</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/15">
                      <span className="poo">
                        <img src={fan} alt="" /> <p>Science & Research</p>
                      </span>
                    </a>
                  </div>
                  <div>
                    <a href="https://www.pdfdrive.com/category/112">
                      <span className="pooo">
                        <img src={most} alt="" /> <p>Most Popular</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/1">
                      <span className="pooo">
                        <img src={art} alt="" /> <p>Art</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/3">
                      <span className="pooo">
                        <img src={bus} alt="" /> <p>Business & Career</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/18">
                      <span className="pooo">
                        <img src={envi} alt="" /> <p>Environment</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/8">
                      <span className="pooo">
                        <img src={heal} alt="" /> <p>Health & Fitness</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/4">
                      <span className="pooo">
                        <img src={grow} alt="" /> <p>Personal Growth</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/10">
                      <span className="pooo">
                        <img src={reli} alt="" /> <p>Religion</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/5">
                      <span className="pooo">
                        <img src={tec} alt="" /> <p>Technology</p>
                      </span>
                    </a>
                  </div>
                </div>
                <p className="inbo">
                  Get Top Trending Free Books in Your Inbox
                </p>
                <span className="emalga">
                  <input type="text" placeholder="Enter you email" />
                  <button>Subscribe</button>
                </span>
                <a href="https://www.pdfdrive.com/app">
                  <img className="mar" src={market} alt="" />
                </a>
                <p className="trendingtoday">Trending Today</p>
                <span className="macb">
                  <img src={mac} alt="" />
                  <p className="perfor">
                    Performance is King: Join The World's Leading <br />
                    Native Ad Network-Revcontent
                  </p>
                  <p className="rev">Revcontent</p>
                </span>
                <span className="macb">
                  <img src={not} alt="" />
                  <p className="perfor">
                    Join Revcontent: Join The World's Fastest <br /> Growing
                    Native Ad Network-Revcontent
                  </p>
                  <p className="rev">Revcontent</p>
                </span>
              </div>
            </div>
          </div>
          <div className="premfooter container">
            <div className="premin container">
              <img className="pdflooo" src={pdflogo} alt="" />

              <div>
                <p>Company</p>
                <a href="https://www.pdfdrive.com/home/about">About</a>
                <br />
                <a href="https://www.pdfdrive.com/app">Mobile App</a> <br />
                <a href="https://www.pdfdrive.com/home/terms">
                  Terms & Privacy
                </a>
              </div>
              <div>
                <p>Social</p>
                <a href="https://twitter.com/pdfdrive">Twitter</a>
                <br />
                <a href="https://www.facebook.com/pdfdrive">Facebook</a> <br />
                <span className="donher">
                  <a href="https://www.pdfdrive.com/donate">Donate</a>
                  <i className="fa fa-heart"></i>
                </span>
              </div>
              <div>
                <p>Help</p>
                <a href="https://www.pdfdrive.com/home/contact">Contact Us</a>
                <br />
                <a href="https://www.pdfdrive.com/home/contact">
                  Feedback
                </a>{" "}
                <br />
                <a href="https://www.pdfdrive.com/home/dmca">
                  DMCA & Copyright
                </a>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Upload;
